import { memo, useEffect, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';

import AccountSlider from 'components/AccountSlider';
import useTopPanel from 'hooks/useTopPanel';
import ConversationTable from 'components/ui/tables/ConversationTable';
import ConversionModal from './ConversionModal';
import AccountFilterDrawer from '../../../components/dashboard/AccountFilterDrawer';

const Account = () => {
  const { setComponent } = useTopPanel();
  const [accountId, setAccountId] = useState('');
  const [accountsError, setAccountsError] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [openConversionModal, setOpenConversionModal] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);

  useEffect(() => {
    setComponent(<div className='component-title'>Konversiyalar</div>);
  }, []);

  return (
    <div className='component-list-wrapper'>
      <AccountSlider
        accountId={accountId}
        setAccountId={setAccountId}
        setAccountsError={setAccountsError}
        emitRefetch={{ refetch, setRefetch }}
      />
      <div className='component-list-header mb-2'>
        <div className='header-actions-container pt-2 pb-2 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center'>
            <Button
              variant='base'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
              onClick={() => !accountsError && setOpenFilter((prev) => !prev)}
              disabled={accountsError}
            >
              Filter
            </Button>
          </div>
          <div className='grow'>
            {/* <SearchInputNavbar inputKey='name' fullWidth /> */}
            <div className='my-2 bg-white h-[45px] rounded-[10px] border' />
          </div>
          <div className='header-actions action-buttons-box flex items-center justify-center ml-4'>
            <Button
              variant='base'
              onClick={() => {
                !accountsError && setRefetch(true);
              }}
              disable={`${refetch}`}
              disabled={accountsError}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              className='!ml-2'
              onClick={() => !accountsError && setOpen(true)}
              disabled={accountsError}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>
      <div className='component-table-wrapper h-[calc(100vh-290px)] flex-auto'>
        {accountId ? (
          <ConversationTable
            emitRefetch={{ refetch, setRefetch }}
            emitTableColumns={{ open, setOpen }}
            dataPath={`admin/accounts/conversations/${accountId}`}
            actionModal={{
              icon: 'bi bi-pen',
              btnColor: 'warning',
              setOpen: setOpenConversionModal,
              setData,
            }}
          />
        ) : !accountsError ? (
          <div className='circular-progress-box'>
            <CircularProgress size={30} />
          </div>
        ) : (
          <div className='my-6'>
            <span className='no-data-found-wrapper'>
              <i className='bi bi-exclamation-octagon text-xl mr-1 leading-3' />{' '}
              Ma'lumot topilmadi!
            </span>
          </div>
        )}
      </div>
      {openConversionModal && (
        <ConversionModal
          open={openConversionModal}
          setOpen={setOpenConversionModal}
          accountId={accountId}
          data={data}
          setData={setData}
          setRefetch={setRefetch}
        />
      )}
      <AccountFilterDrawer open={openFilter} setOpen={setOpenFilter} />
    </div>
  );
};

export default memo(Account);
